// @vendors
import React from 'react'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { theme } from '../assets/theme'

const Pageheader = ({title, subtitle}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '10px',
        alignItems: 'flex-start'
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "20px", md: "28px" },
          fontWeight: "bold",
          lineHeight: '21px',
          color: theme.palette.primary.black,
        }}
        variant="h1"
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: "16px", md: "24px" },
          lineHeight: '20px',
          color: theme.palette.primary.black,
        }}
        variant="h3"
      >
        {subtitle}
      </Typography>
    </Box>
  )
}

export default Pageheader